import { render, staticRenderFns } from "./ClienteHome.vue?vue&type=template&id=4b76c3ad&scoped=true&"
import script from "./ClienteHome.vue?vue&type=script&lang=js&"
export * from "./ClienteHome.vue?vue&type=script&lang=js&"
import style0 from "./ClienteHome.vue?vue&type=style&index=0&id=4b76c3ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b76c3ad",
  null
  
)

export default component.exports